import * as React from "react";
import styled from "@mui/material/styles/styled";
import { LoginWidget } from "user-management/src/components/loginWidget";
import { useHistory } from "react-router";
//region [[ Styles ]]
const PatientLoginView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
}));

//endregion [[ Styles ]]
//region [[ Props ]]
export interface PatientLoginProps {}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const PatientLogin = ({ ...props }: PatientLoginProps) => {
  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);

  return (
    <PatientLoginView>
      <LoginWidget
        onSignIn={() => history.push(queryParams.get("returnto") || "/welcome")}
        onForgotPasswordClick={() => history.push("forgot_password")}
        onSignUpClick={() => history.push("signup")}
      />
    </PatientLoginView>
  );
};
